import { api, ApiListResponse, commonApiWrapper } from "@/services/common-api";
import { ICityV2 } from "@/app/dashboard/models/City";

export const getCitiesForHomePage = () =>
  commonApiWrapper<ApiListResponse<ICityV2>>(api.get("/city/public"));

export const getCityNames = () =>
  commonApiWrapper<ApiListResponse<ICityV2>>(
    api.get("/city/names")
  );
